var React = require('react');

function LocationIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.80185 0.0296864C3.44934 0.332156 0.66028 2.83441 0.0968332 6.07908C0.0686609 6.21657 0.0404894 6.38155 0.0404894 6.51904C-0.128545 8.03139 0.237696 9.54374 1.02652 10.8636L7.47799 22L14.0985 10.6436C14.6901 9.62623 15 8.49884 15 7.31646C15 3.05439 11.2531 -0.355275 6.80185 0.0296864ZM10.9995 9.02129C10.9995 9.04879 10.9714 9.10378 10.9432 9.10378L7.53433 11.0286C7.50616 11.0561 7.44981 11.0561 7.42164 11.0286L4.01279 9.10378C3.98461 9.07629 3.95644 9.04879 3.95644 9.02129V5.17167C3.95644 5.14418 3.98461 5.08918 4.01279 5.08918L7.42164 3.16437C7.44981 3.13688 7.50616 3.13688 7.53433 3.16437L10.9432 5.08918C10.9714 5.11668 10.9995 5.14418 10.9995 5.17167V9.02129Z","fill":"white"}));
}

LocationIcon.defaultProps = {"width":"15","height":"22","viewBox":"0 0 15 22","fill":"none"};

module.exports = LocationIcon;

LocationIcon.default = LocationIcon;
